import { EulaSection } from '../../services/api/eula'

export const parseEulaContent = (content: string): EulaSection[] => {
  try {
    const parsed = JSON.parse(content) as unknown

    if (
      Array.isArray(parsed) &&
      parsed.every(
        (section) =>
          typeof section === 'object' &&
          section !== null &&
          'title' in section &&
          'body' in section
      )
    ) {
      return parsed as EulaSection[]
    }
  } catch {
    // fall through to plain text content
  }

  return [{ title: '', body: content }]
}
